import type { Person } from '@/store/people/types';
import { useMemo } from 'react';
import {
  type FieldInteraction,
  FieldDisplay,
  type PersonFieldKey,
} from '../people/people/fields';
import { Title } from './title';

export function Details({ person }: { person: Person }) {
  const fieldInfo = useMemo(() => {
    const keys = [
      'firstname',
      'lastname',
      'preferredname',
      'fullname',
      'gender',
      'birthdate',
      'marital_status',
      'email',
      'phone',
      'member_status',
      'campus_id',
      'laygroup1',
      'laygroup2',
    ];

    return keys.map((key) => ({
      key,
      interaction: { isReadOnly: true } as FieldInteraction,
    }));
  }, []);

  return (
    <div className='flex flex-col gap-4'>
      <Title>Profile Information</Title>
      {fieldInfo.map((info) => (
        <FieldDisplay
          key={info.key}
          fieldKey={info.key as PersonFieldKey}
          editable={person}
          target={person}
          interaction={info.interaction}
          onStringChange={() => {}}
          onGenderChange={() => {}}
          onBirthdateChange={() => {}}
          onCampusChange={() => {}}
          onLayGroupChange={() => {}}
        />
      ))}
    </div>
  );
}
